import React from "react";
import Hero from "./subComponents/Hero";
import SobreWhisky from './subComponents/SobreWhisky';
import CataWhiskyExperience from "./subComponents/CataWhiskyExperience";
import ProductosDestacados from "../Productos/ProductosDestacados";
import ContactoBanner from "./subComponents/ContactoBanner";
import SEO from "../SEO/SEO";


const Inicio = () => {
  return (
   <>
  <SEO
   title="Whisky And Co | El mejor whisky de Cordoba"
   description="Whisky & Co | apasionados por el whisky - Encontra el mejor whisky"
   canonicalPath="/"
  />

   <Hero />
   <ProductosDestacados />
   <SobreWhisky />
   <CataWhiskyExperience />
   <ContactoBanner />
   </>
  );
};

export default Inicio;
